import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Grupo } from 'app/models/grupo-model';
import { Services } from 'app/servicios.service';

@Component({
  selector: 'app-grupo',
  templateUrl: './grupo.component.html',
  styleUrls: ['./grupo.component.css']
})
export class GrupoComponent implements OnInit {

  public Grupos: Array<Grupo>;
  public cantGrupos: Number;
  public loading: boolean;
  constructor(public API: Services, private router: Router) { }

  ngOnInit(): void {
    this.cantGrupos = 0;
    this.loading = true;
    this.API.getGrupos().subscribe(data => {
      this.Grupos = data;
      this.Grupos.forEach(function(grupo){
        grupo.Imagen.Ruta = "https://pabloarenas.uy/intranet"+grupo.Imagen.Ruta.replace('..','');
      });
      this.loading = false;
    })
  }

  getBackground(back: string){
    return "url('"+back+"')";
  }

  redirect(id: Number){
    console.log(id);
    this.router.navigate(['./destinos/'+id.toString()]);
  }

}
